import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'

let androidBackListenerRegistered = false

function triggerNavbarBack () {
  const lobbyStep2 = document.getElementById('lobby-step2')
  if (lobbyStep2?.classList.contains('is-active')) {
    const lobbyBack = document.querySelector('[data-lobby-target="backButton"]')
    if (lobbyBack) {
      lobbyBack.click()
      return true
    }
  }

  const backArrow = document.getElementById('back-arrow')
  if (backArrow) {
    backArrow.click()
    return true
  }

  return false
}

/**
 * Native shell tweaks when the app runs inside the Capacitor WebView
 * (Rails is loaded via server.url — this code ships with the webpack pack).
 */
export function initCapacitorNativeShell () {
  if (!Capacitor.isNativePlatform()) return

  if (Capacitor.getPlatform() !== 'android' || androidBackListenerRegistered) return
  androidBackListenerRegistered = true

  App.addListener('backButton', ({ canGoBack }) => {
    if (triggerNavbarBack()) return

    if (canGoBack) {
      window.history.back()
      return
    }

    App.minimizeApp().catch(() => {})
  })
}
